export const flipTime = 0.7;
export const flipDelay = flipTime ** 3 * 1000;

export const darkThemeIdentifier = "(prefers-color-scheme: dark)";
